import MarkSafe from 'topmeteo/general/components/MarkSafe';

const NotAvailable = () => <span>N/A</span>;

const Icon = ({iconClass}) => (
    <span className={`ov ov-${iconClass}`}>
        <i className={`icon icon-${iconClass}`} />
    </span>
);

const Value = ({value, color, bgColor}) => (
    <MarkSafe
        html={value || '&nbsp;'}
        style={{
            color: color || 'inherit',
            backgroundColor: bgColor || 'inherit',
        }}
    />
);

const getTypeElement = type => {
    if (type === 'not-available') return NotAvailable;

    return type ? Icon : Value;
};

const Column = ({type, ...props}) => {
    const Type = getTypeElement(type);

    return (
        <td className="product-content">
            <Type {...props} />
        </td>
    );
};

export default Column;
